import "core-js/modules/es6.array.find.js";
export var cards = function cards(state) {
  return state.cards;
};
export var defaultCard = function defaultCard(state) {
  return state.cards ? state.cards.find(function (card) {
    return card.isDefault();
  }) : null;
};